import React, { Component } from 'react';
import acceso from "../../assets/acceso.svg";
import home from "../../assets/home.svg";
import cerrar from "../../assets/cerrarSesion.svg";
import '../../css/admin/NavBarInfo.css';
import { memo } from 'react';

export class NavBarInfo extends Component {

    constructor(props){
        super(props);
        
        this.state={
            inicioSesion:"",
        }
        this.fechaActual=this.fechaActual.bind(this);

    }

    fechaActual(){
        var tiempoTranscurrido = Date.now()
        var hoy = new Date(tiempoTranscurrido)
        this.setState({inicioSesion: hoy.toLocaleDateString()});
    }

    componentDidMount(){
        this.fechaActual();
    }

    render() {
    return (
        <div className="row" id='navBarInfo-divNavbar' >
            <div className="col-md-9 col-lg-9">
            </div>
            <div className='col-md-3 col-lg-3' id="navBarInfo-myNavbar">
                <div className='navBarInfo-texto-ultimaVez mt-3'>
                    <span>Inicio de sesión: {this.state.inicioSesion}</span>
                    <button className='navBarInfo-btn-iconos'><img className="navBarInfo-logos-ultimaActualizacion" src={acceso} alt="Acceso"></img></button>
                    <button className='navBarInfo-btn-iconos'><img className="navBarInfo-logos-ultimaActualizacion" src={home} alt="Home"></img></button>
                    <button className='navBarInfo-btn-iconos' onClick={this.props.cerrarSesion}><img className="navBarInfo-logos-ultimaActualizacion" src={cerrar} alt="Cerrar sesión"></img></button>
                </div>
            </div>
        </div>
    );
  }
}

export default memo(NavBarInfo);
